module.exports = __webpack_public_path__ + "static/media/wire.c09d0d30.svg";